<template>
  <div>
    <v-card>
      <v-toolbar dark dense color="orange" class="pb-0 mb-0">
        Actions Needing Your Attention
        <v-spacer></v-spacer>
        <!-- <v-btn @click="expandedFilters = !expandedFilters" flat>
          <span v-if="expandedFilters">Hide Filters</span>
          <span v-if="!expandedFilters">Show Filters</span>
        </v-btn> -->
        <v-btn flat @click="dismissActions()" :loading="dismissLoading"
          >Dismiss Selected</v-btn
        >
        <v-btn flat @click="resetFilters()">Clear Grid Filters</v-btn>
      </v-toolbar>
      <v-card-text>
        <!-- <v-slide-y-transition>
          <v-layout row wrap v-if="expandedFilters">
            <v-flex xs4>
              <v-text-field
                v-model="search"
                v-on:input="onQuickFilterChanged"
                label="Search"
                prepend-icon="mdi-magnify"
                clearable
              ></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-autocomplete
                v-model="agGridFilter.categoryFilter"
                label="Category Filter"
                small-chips
                multiple
                clearable
                :items="categories"
                item-text="name"
                item-value="id"
                @change="updateFilter"
              >
                <template #selection="{ item }">
                  <v-chip
                    class="pr-0"
                    color="#4cc7e8"
                    style="color: white; font-weight: bold"
                    small
                    >{{ item.name }}
                    <v-icon
                      color="white"
                      @click="removeCategory(item)"
                      style="
                        font-size: 12pt;
                        margin-right: -8px;
                        margin-left: 2px;
                      "
                      >mdi-close</v-icon
                    >
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-flex>
            <v-flex xs4>
              <v-autocomplete
                v-model="agGridFilter.subCategoryFilter"
                label="Sub Category Filter"
                small-chips
                multiple
                clearable
                :items="subCategories"
                item-text="name"
                item-value="id"
                @change="updateFilter"
              >
                <template #selection="{ item }">
                  <v-chip
                    class="pr-0"
                    color="#4cc7e8"
                    style="color: white; font-weight: bold"
                    small
                    >{{ item.name }}
                    <v-icon
                      color="white"
                      @click="removeSubCategory(item)"
                      style="
                        font-size: 12pt;
                        margin-right: -8px;
                        margin-left: 2px;
                      "
                      >mdi-close</v-icon
                    >
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-flex>
          </v-layout>
        </v-slide-y-transition> -->

        <v-layout row wrap>
          <!-- <v-flex xs12 class="py-0"> -->
          <!-- STATS BAR -->
          <!-- <div
              style="
                width: 100%;
                text-align: center;
                font-weight: bold;
                background: #4cc7e8;
                border-radius: 5px;
                color: white;
              "
              class="mb-2 pa-2"
            >
              <span style="float: left"
                >Total Enq: {{ statsData.totalEnq }}</span
              >
              Total Rev:
              {{ statsData.totalRev }}
              <span style="float: right"
                >Total Contribution: {{ statsData.totalUC }}</span
              >
            </div>
          </v-flex> -->
          <v-flex xs12 class="py-0">
            <ag-grid-vue
              :style="{ width, height }"
              class="ag-theme-alpine"
              :defaultColDef="defaultColDef"
              :columnDefs="columnDefs"
              :rowData="rowData"
              :animateRows="true"
              :rowBuffer="5"
              :pagination="true"
              rowSelection="multiple"
              :rowDeselection="true"
              @grid-ready="onGridReady"
              @cellDoubleClicked="onCellDoubleClick"
            ></ag-grid-vue>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import { AgGridVue } from "ag-grid-vue";

export default {
  props: ["data"],
  components: {
    AgGridVue,
  },
  data: () => ({
    //AG-Grid
    columnDefs: null,
    rowData: null,
    pinnedBottomRowData: null,
    columnApi: null,
    gridApi: null,
    defaultColDef: {
      sortable: true,
      filter: true,
      resizable: true,
      autoHeight: true,
    },
    width: "100%",
    height: "650px",
    search: "",

    // Filters
    searchDebounce: null,
    // agGridFilter: {
    //   yearFilter: "All",
    //   categoryFilter: [],
    //   subCategoryFilter: [],
    // },
    // yearFilterArray: ["All"],

    // expandedFilters: true,
    // statsData: {
    //   totalEnq: 0,
    //   totalRev: 0,
    //   totalUC: 0,
    // },
    dismissLoading: false,
  }),
  computed: {
    ...mapGetters({}),
  },
  watch: {
    data: function(oldSE, newSE) {
      this.setGridData(this.data);
    },
  },
  mounted() {
    this.setGridData(this.data);
    this.columnDefs = [
      {
        headerName: "Created On",
        field: "created_at",
        width: "150",
        valueFormatter: (params) => {
          if (params.data.created_at != "") {
            return moment(params.data.created_at).format("DD-MMM HH:mm");
          } else {
            return "";
          }
        },
      },
      {
        headerName: "Action Type",
        field: "type",
        width: "300",
      },
      {
        headerName: "Status",
        field: "status",
        width: "150",
      },
      {
        headerName: "Message",
        field: "value",
        width: "500",
      },
      {
        headerName: "Created By",
        field: "created_by_name",
      },
      {
        headerName: "Due Date",
        field: "dueBy",
        valueFormatter: (params) => {
          if (params.data.dueBy != "") {
            return moment(params.data.dueBy).format("DD-MMM");
          } else {
            return "No Due Date";
          }
        },
      },
    ];
  },
  methods: {
    // updateSumTotals() {
    //   let model = this.gridApi.getModel();
    //   let rows = model.rowsToDisplay;
    //   this.statsData = {
    //     totalEnq: 0,
    //     totalRev: 0,
    //     totalUC: 0,
    //   };
    //   rows.forEach((row) => {
    //     if (row.data.impactInterestedStatus == "Prospecting") {
    //       this.statsData.prospectingBuyers += 1;
    //     } else if (row.data.impactInterestedStatus == "Open") {
    //       this.statsData.openBuyers += 1;
    //     } else if (row.data.impactInterestedStatus == "Not Interested") {
    //       this.statsData.notInterestedBuyers += 1;
    //     }

    //     this.statsData.totalEnq += 1;
    //     if (row.data.revenue != "") {
    //       this.statsData.totalRev += parseFloat(row.data.revenue);
    //     }
    //     if (row.data.cC != "") {
    //       this.statsData.totalUC += parseFloat(row.data.cC);
    //     }
    //   });
    //   this.statsData.totalUC = formatter.format(this.statsData.totalUC);
    //   this.statsData.totalRev = formatter.format(this.statsData.totalRev);
    // },
    // filterSuppliersData() {
    //   if (this.data.length > 0) {
    //     let filteredData = [];
    //     if (this.year == "Combined Years") {
    //       filteredData = JSON.parse(
    //         JSON.stringify(this.combinedData.filter((s) => s.business_id != ""))
    //       );
    //     } else {
    //       if (this.month == 0) {
    //         filteredData = JSON.parse(
    //           JSON.stringify(
    //             this.data.filter(
    //               (s) => s.business_id != "" && s.year == this.year
    //             )
    //           )
    //         );
    //       } else {
    //         filteredData = JSON.parse(
    //           JSON.stringify(
    //             this.monthData.filter(
    //               (s) =>
    //                 s.business_id != "" &&
    //                 s.year == this.year &&
    //                 s.month == this.month
    //             )
    //           )
    //         );
    //       }
    //     }
    //     this.setGridData(filteredData);
    //   }
    // },
    setYearFilterArray() {
      let year = new Date().getFullYear();
      for (let i = year; i >= 2018; i--) {
        this.yearFilterArray.push(i);
      }
    },
    resetFilters() {
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();
    },
    updateFilter() {
      this.gridApi.onFilterChanged();
    },
    isExternalFilterPresent() {
      return true;
    },
    // doesExternalFilterPass(node) {
    //   let passed = 0;
    //   // Category Filter
    //   if (
    //     this.agGridFilter.categoryFilter.length != 0 &&
    //     this.agGridFilter.categoryFilter != "0"
    //   ) {
    //     let foundMatch = node.data.category
    //       .split(",")
    //       .find((val) => this.agGridFilter.categoryFilter.includes(val));
    //     if (typeof foundMatch != "undefined") {
    //       passed += 1;
    //     }
    //   } else {
    //     passed += 1;
    //   }

    //   // Category Filter
    //   if (
    //     this.agGridFilter.subCategoryFilter.length != 0 &&
    //     this.agGridFilter.subCategoryFilter != "0"
    //   ) {
    //     let foundMatch = node.data.subCategory
    //       .split(",")
    //       .find((val) => this.agGridFilter.subCategoryFilter.includes(val));
    //     if (typeof foundMatch != "undefined") {
    //       passed += 1;
    //     }
    //   } else {
    //     passed += 1;
    //   }

    //   if (passed == 2) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },

    setGridData(data) {
      let rowData = JSON.parse(JSON.stringify(data));
      // rowData.pop();
      // const pinnedRow = [data[data.length - 1]];

      // this.gridApi.setPinnedBottomRowData(pinnedRow);
      setTimeout(() => {
        this.gridApi.setRowData(rowData);
        // this.updateSumTotals();

        // var allColumnIds = [];
        // this.columnApi.getAllColumns().forEach(function (column) {
        //   if (column.colDef.suppressSizeToFit != true) {
        //     allColumnIds.push(column.colId);
        //   }
        // });
        // // this.gridApi.sizeColumnsToFit();
        // this.columnApi.autoSizeColumns(allColumnIds, false);
      }, 50);
    },
    onQuickFilterChanged() {
      clearTimeout(this.searchDebounce);

      this.searchDebounce = setTimeout(() => {
        this.gridApi.setQuickFilter(this.search);
      }, 150);
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      if (this.data.length != 0) {
        this.setGridData(this.data);
      }
    },
    onCellDoubleClick(cell) {
      console.log(cell.data);
      if (cell.data.redirect_url != "") {
        console.log(
          cell.data.redirect_url.replace("==ref_id==", cell.data.ref_id)
        );
        this.$router.push(
          cell.data.redirect_url.replace("==ref_id==", cell.data.ref_id)
        );
      }
    },
    updateAGGridActionMenu() {
      this.$store.dispatch("agGrid/setAGGridActionMenuState", {});
    },
    viewStockDetails() {
      this.open(this.selectedRowData);
    },
    formatDate(date) {
      return date.slice(0, 11);
    },
    dismissActions() {
      this.dismissLoading = true;
      let rows = this.gridApi.getSelectedRows();
      let ids = [];
      rows.forEach((row) => {
        ids.push(row.id);
      });
      this.$store
        .dispatch("actionCenter/dismissMultiple", { ids: ids })
        .then(() => {
          this.dismissLoading = false;
        });
    },
  },
  filters: {
    moment: function(date) {
      return moment
        .utc(date)
        .local()
        .format("MMM Do YYYY, h:mm a");
    },
  },
};
</script>

<style lang="css">
#stats-grid .ag-body-horizontal-scroll {
  display: none;
}
</style>
